// File: src/components/layouts/Core/Spacer/Spacer.tsx
// Purpose: Layout or container component

import React from "react";
import styled from "styled-components";
import { AppTheme } from "theme";

export interface SpacerProps {
  size?:  keyof AppTheme["spacing"]; // Uses theme spacing (xxs, xs, sm, md, lg, xl, xxl)
  direction?: "vertical" | "horizontal"; // Determines if spacing is row or column-based
  flex?: boolean; // Allows Spacer to be used in Flex layouts
}

const StyledSpacer = styled.div<SpacerProps>`
  display: ${({ flex }) => (flex ? "flex" : "block")};
  width: ${({ direction, size, theme }) =>
    direction === "horizontal" ? theme.spacing[size || "md"] : "100%"};
  height: ${({ direction, size, theme }) =>
    direction === "vertical" ? theme.spacing[size || "md"] : "auto"};
`;

export const Spacer: React.FC<SpacerProps> = ({ size = "md", direction = "vertical", flex = false }) => {
  return <StyledSpacer size={size} direction={direction} flex={flex} />;
};